const waitReady = () => {
    setTimeout(() => {//定时检查一次
        if (window.TinperNext) {
            import('./app'); //运行入口
        } else {
            waitReady(); //不存在则继续等待检查
        }
    }, 10)
}
waitReady();
